/* eslint-disable no-loop-func */
import initState from "./initState";

import * as types from "store/types";
import { updateObject, deepClone } from "utils";

function fetchUsersListStart(state, action) {
  return updateObject(state, {
    loading: true
  });
}

function fetchUsersListSuccess(state, action) {
  return updateObject(state, {
    loading: false,
    list: action.users
  });
}

function inviteUsersFailure(state, action) {
  return updateObject(state, {
    popupLoading: false,
    list: state.list,
    inviteFailure: action.msg
  });
}

function inviteUsersSuccess(state, action) {
  let inviteSuccess = false;
  if (action.invites.invalid_email.length === 0) {
    inviteSuccess = true;
  }
  return updateObject(state, {
    addUsers: updateObject(state.addUsers, {
      inviteStatus: updateObject(state.addUsers.inviteStatus, {
        invalid_email: action.invites.invalid_email,
        invite_email: action.invites.invite_email
      }),
      success: updateObject(state.addUsers.success, {
        show: inviteSuccess ? true : false,
        msg: inviteSuccess
          ? action.invites.invite_email.length > 1
            ? "Users Added Successfully."
            : "User Added Successfully."
          : ""
      })
    }),
    popupLoading: false
  });
}

function resendInvitationSuccess(state, action) {
  const updatedState = { ...state };
  updatedState.list.map(user => {
    if (user.emailid === action.email) {
      user.accountStatus = "R";
    }
    return user;
  });
  updatedState.inviteEmail = action.email;
  return updatedState;
}

function resendInvitationFailed(state, action) {
  const updatedState = { ...state };
  updatedState.list.map(user => {
    if (user.emailid === action.email) {
      user.accountStatus = "F";
    }
    return user;
  });
  updatedState.inviteEmail = action.email;
  return updatedState;
}

function resetAccountStatus(state, action) {
  const updatedState = { ...state };
  updatedState.list.map(user => {
    if (user.emailid === action.email) {
      user.accountStatus = "";
    }
    return user;
  });
  updatedState.inviteEmail = "";
  return updatedState;
}

function inviteUsersStart(state, action) {
  if (action.resend) {
    return updateObject(state, {
      addUsers: updateObject(state.addUsers, {
        addUserInviteResent: true
      }),
      popupLoading: true
    });
  } else {
    return updateObject(state, {
      addUsers: updateObject(state.addUsers, {
        addUserInviteResent: false
      }),
      popupLoading: true
    });
  }
}

function deleteSubUserSuccess(state, action) {
  return updateObject(state, {
    removeSubuser: updateObject(state.removeSubuser, {
      status: { show: true, error: false, isInvite: action.isInvite }
    })
  });
}

function deleteSubUserFailed(state, action) {
  return updateObject(state, {
    removeSubuser: updateObject(state.removeSubuser, {
      status: { show: true, error: true, isInvite: action.isInvite }
    })
  });
}

function copyToClipboard(state, action) {
  return updateObject(state, {
    copiedInvite: action.status
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_USERS_LIST_START:
      return fetchUsersListStart(state, action);
    case types.FETCH_USERS_LIST_SUCCESS:
      return fetchUsersListSuccess(state, action);
    case types.INVITE_USERS_FAILURE:
      return inviteUsersFailure(state, action);
    case types.INVITE_USERS_SUCCESS:
      return inviteUsersSuccess(state, action);
    case types.RESEND_INVITATION_SUCCESS:
      return resendInvitationSuccess(state, action);
    case types.RESEND_INVITATION_FAILED:
      return resendInvitationFailed(state, action);
    case types.RESET_INVITATION_ACCOUNT_STATUS:
      return resetAccountStatus(state, action);
    case types.INVITE_USERS_START:
      return inviteUsersStart(state, action);
    case types.DELETE_SUBUSER_SUCCESS:
      return deleteSubUserSuccess(state, action);
    case types.DELETE_SUBUSER_FAILED:
      return deleteSubUserFailed(state, action);
    case types.COPY_TO_CLIPBOARD:
      return copyToClipboard(state, action);
    default:
      return state;
  }
}

export default reducer;
